exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pivot-table-widget[data-v-0be9fa2e]{height:calc(100% - 50px);width:100%}.pivot-table-widget .table-box[data-v-0be9fa2e]{width:100%;height:100%}.no-data[data-v-0be9fa2e]{font-size:14px}.no-data .lh[data-v-0be9fa2e]{color:var(--el-color-primary)}\n", ""]);

// exports
